import Text from 'components/Text';
import styled from 'styled-components';

interface CustomerProfileOverviewProps {
  label: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

const CustomerProfileOverview = ({ label, icon, children }: CustomerProfileOverviewProps) => {
  return (
    <CustomerProfileOverviewStyled>
      <TextStyled variant='CONTENT_3' color='#33a2b6'>{label}</TextStyled>
      <TextStyled variant='CONTENT_2' color='#505050' className='content'>
        {children}
      </TextStyled>
      {icon && <IconBoxStyled>{icon}</IconBoxStyled>}
    </CustomerProfileOverviewStyled>
  );
};

export default CustomerProfileOverview;

const CustomerProfileOverviewStyled = styled.div`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  background: #fff;
  position: relative;

  ul {
    padding-inline-start: 20px;
    margin: 0;
  }

  .content {
    padding-right: 40px;
  }
`;

const IconBoxStyled = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
`;

const TextStyled = styled(Text)<{ color?: string }>`
  color: ${({ color }) => color || '#1D2129'};
  font-size: 1.5em !important;
`;
